import type { WrappedFieldProps } from "redux-form";

import { DateField } from "@js/forms/fields";

export const IssuedAtField = ({ input, meta }: WrappedFieldProps) => {
  return (
    <DateField
      input={input}
      meta={meta}
      label="Date"
      id="issued_at"
      readOnly
      disabled
      error={meta.error}
    />
  );
};
